<template>
  <div class="form_skeleton">
    <div class="form_skeleton_title">
      <span class="title_text">
        <slot name="title"></slot>
      </span>
    </div>
    <div class="form_skeleton_content">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'FormSkeleton',
  }
</script>

<style lang="scss" scoped>
  .form_skeleton {
    padding: 10px;
    .form_skeleton_title {
      .title_text {
        font-weight: 700;
        border-radius: 8px 8px 0 0;
        padding: 4px 8px 0 8px;
        background-color: #fff;
      }
    }
    .form_skeleton_content {
      background-color: #fff;
      border-radius: 0 8px 8px 8px;
      padding: 20px;
    }
  }
</style>
